import React from 'react';
import Notification, { NotificationProps } from './notification';

interface NotificationContainerProps {
  notifications: NotificationProps[];
  onRemove: (id: string) => void;
}

const NotificationContainer: React.FC<NotificationContainerProps> = ({
  notifications,
  onRemove,
}) => {
  return (
    <div className="fixed top-16 left-0 right-0 z-50 pointer-events-none" style={{ maxWidth: '414px', margin: '0 auto' }}>
      <div className="w-full px-4 space-y-3">
      {notifications.map((notification, index) => (
          <div
            key={notification.id}
            className="pointer-events-auto w-full"
            style={{
              zIndex: 1000 - index,
            }}
          >
            <Notification
              {...notification}
              onClose={onRemove}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default NotificationContainer; 